(ns guidebook.views.value-relationships
  (:require
    [reagent.core :as r]
    [util.core :refer [valid-date? to-local-year]]
    [very.re-frame.core :as rf :refer [>evt]]
    [guidebook.common :as gc]
    [css.vars :as vars]
    [cljss.core :as cljss]
    [css.core
     :refer [get-theme]
     :refer-macros [defstyled]]))

(defstyled values-s :div
  {:width "calc(100% - 50px)"
   :margin-left "50px"
   :min-height "100vh"
   :padding "150px 150px 150px 100px"
   :display "grid"
   :grid-template-columns "1fr"
   :grid-template-rows "min-content min-content auto"
   :background-image "url(/assets/road.png)"
   :background-repeat "no-repeat"
   :background-position "center"
   :background-size "cover"
   ::cljss/media {[:print]
                  {:display "flex"
                   :flex-direction "column"
                   :align-items "center"
                   :padding "50px 100px"
                   :margin-top "50px"}}})

(defstyled title-container-s :div
  {::cljss/media {[:print]
                  {:background "black"
                   :padding "100px"
                   :margin-left "-150px"
                   :width "740px"
                   :align-self "flex-start"}}})

(defstyled print-description-s :div
  {:display "none"
   ::cljss/media {[:print]
                  {:display "block"}}})

(defstyled pres-description-s :div
  {::cljss/media {[:print]
                  {:display "none"}}})

(defstyled timeline-outer-s :div
  {:margin "75px 50px 120px"
   :position "relative"
   ::cljss/media {[:print]
                  {:width "100%"
                   :margin "0 0 120px"}}})

(defstyled timeline-inner-s :div
  {:overflow "hidden"
   :width "calc(100vw - 400px)"
   :display "grid"
   ::cljss/media {[:print]
                  {:width "100%"}}})

(defstyled timeline-bar-s :div
  {:border-bottom "1px solid white"
   ::cljss/media {[:print]
                  {:grid-column "center"
                   :border-bottom "none"
                   :width "1px"
                   :height "100%"
                   :background "white"
                   :position "absolute"
                   :left "0"
                   :right "0"
                   :margin "auto"}}})

(defstyled timeline-list-s :ol
  {:display "grid"
   :transition "transform 1s ease-in-out"
   :list-style-type "none"
   :margin "0"
   :padding "0"
   ::cljss/media {[:print]
                  {:display "flex"
                   :flex-direction "column"
                   :transform "translateX(0) !important"}}})

(defstyled timeline-item-s :li
  {:page-break-inside "avoid"
   :display "flex"
   :align-items "flex-end"})

(defstyled control-button-s :button
  {:position "absolute"
   :bottom "12px"
   :cursor "pointer"
   :left (with-meta #(if (= % "left") "-80px" "auto") :location)
   :right (with-meta #(if (= % "right") "-80px" "auto") :location)
   :background-image (with-meta #(if (= % "left") "url(/assets/icons/arrow--left.svg)" "url(/assets/icons/arrow--right.svg)") :location)
   :background-position "center"
   :background-color "transparent"
   :border "none"
   :background-size "contain"
   :background-repeat "no-repeat"
   :height "62px"
   :width "62px"
   :&:disabled {:display "none"}
   ::cljss/media {[:print]
                  {:display "none"}}})

(defstyled card-container-s :div
  {:margin "auto"
   :width "90%"
   :border "10px solid rgba(255, 255, 255, 0.5)"
   ::cljss/media {[:print]
                  {:width "100%"
                   :margin "0"
                   :color (with-meta identity :parity)
                   :grid-column (with-meta #(if (= % "odd") "big2" "big1") :parity)
                   :grid-row "1"}}})

(defstyled relationship-s :div
  {:position "relative"
   :width "calc(33.3333vw - 133.3333px)"
   ::cljss/media {[:print]
                  {:width "100%"
                   :display "grid"
                   :grid-template-columns "[big1-start] 35fr [big1-end small1-start] 15fr [small1-end center-start] min-content [center-end small2-start] 15fr [small2-end big2-start] 35fr [big2-end]"
                   :grid-template-rows "1fr"
                   :align-items "center"
                   :justify-content "center"
                   :padding "100px 0 0"
                   :page-break-inside "avoid"}}})

(defstyled card-text-s :div
  {:background-color "white"
   :padding "20px 40px"
   :min-height "100px"
   :display "flex"
   :align-items "center"
   :justify-content "center"
   :font-size "25px"
   :line-height "36px"
   :font-weight "300"
   ::cljss/media {[:print]
                  {:font-size "20px"
                   :line-height "28px"
                   :padding "15px 30px"
                   :min-height "0"}}})

(defstyled marker-dashes-s :div
  {:display "flex"
   :flex-direction "column"
   :align-items "center"
   :margin-top "13px"
   ::cljss/media {[:print]
                  {:flex-direction "row"
                   :margin "0"
                   :grid-column (with-meta #(if (= % "odd")"small2" "small1") :parity)
                   :grid-row "1"
                   :justify-content "center"}}})

(defstyled marker-dash-s :div
  {:width "3px"
   :height "10px"
   :margin-bottom "8px"
   :border-radius "2px"
   :background "#eeeeee"
   ::cljss/media {[:print]
                  {:margin "0 5px 0"
                   :width "10px"
                   :height "3px"}}})

(defstyled relationship-date-s :div
  {:color "white"
   :font-size "22px"
   :font-weight "300"
   :text-align "center"
   :margin-top "20px"
   ::cljss/media {[:print]
                  {:margin "0"
                   :grid-column (with-meta #(if (= % "odd")"small1" "small2") :parity)
                   :grid-row "1"
                   :font-size "20px"}}})

(defstyled marker-circle-s :div
  {:height "9px"
   :width "9px"
   :background "white"
   :border-radius "100%"
   :position "absolute"
   :left "0"
   :bottom "38px"
   :right "0"
   :margin "auto"
   ::cljss/media {[:print]
                  {:position "static"
                   :grid-column "center"
                   :grid-row "1"
                   :top "0"
                   :bottom "0"}}})

(defstyled circle-focus-container-s :div
  {:height "27px"
   :width "54px"
   :overflow "hidden"
   :position "absolute"
   :left "0"
   :right "0"
   :bottom "43px"
   :transition "opacity .25s ease-in"
   :margin "auto"
   ::cljss/media {[:print]
                  {:display "none"}}})

(defstyled circle-focus-s :div
  {:height "54px"
   :width "54px"
   :background "rgba(255, 255, 255, .5)"
   :border "5px solid white"
   :border-radius "100%"})

(defstyled current-year-s :div
  {:background "black"
   :padding "30px 60px"
   :position "absolute"
   :right "-185px"
   :bottom "-290px"
   ::cljss/media {[:print]
                  {:display "none"}}})

(defn card [{:keys [notes parity]}]
  [card-container-s {:parity parity}
   [card-text-s notes]])

(defn relationship [{:keys [date notes]} highlighted idx]
  (let [parity (if (even? (inc idx)) "even" "odd")]
    [relationship-s
     [card {:notes notes
            :parity parity}]
     [marker-dashes-s {:parity parity}
      [marker-dash-s]
      [marker-dash-s]
      [marker-dash-s]
      [marker-dash-s]
      [marker-dash-s]
      [marker-dash-s]]
     [marker-circle-s]
     [circle-focus-container-s {:style {:opacity (if (= idx highlighted) "1" "0")}}
      [circle-focus-s]]
     [timeline-bar-s]
     [relationship-date-s {:parity parity} (gc/format-date date)]]))

(defn current-year [{:keys [date]}]
  [current-year-s
   [gc/title-s {:color "white"
                :margin "0"} (to-local-year date)]])

(defn main []
  (let [vr (rf/subscribe [:guidebook/value-relationships])
        highlighted (r/atom 0)]
    (fn []
      [values-s
       [title-container-s
        [gc/title-s {:color "white"} "Life's Moments"]
        [print-description-s [gc/text {:color "white"
                                       :width "400px"} "We realize that looking at your entire life; from accomplishments to goals and setbacks, helps us to define a relationship that takes all parts of your life into account.  We believe this benefits you holistically."]]]
       [timeline-outer-s
        [control-button-s {:disabled (<= @highlighted 0)
                           :on-click #(swap! highlighted dec)
                           :location "left"}]
        [timeline-inner-s
         (into [timeline-list-s {:style {:gridTemplateColumns (str "repeat(" (count @vr) ", 1fr)")
                                         :transform (str "translateX(" (* -33.3333 @highlighted) "vw) translateX(" (* 133.3333 @highlighted) "px)")}}]
               (for [[card idx] (map vector @vr (range))]
                 [timeline-item-s
                  [relationship card @highlighted idx]]))]
        [control-button-s {:disabled (or (zero? (count @vr))
                                         (= (count @vr) (inc @highlighted)))
                           :on-click #(swap! highlighted inc)
                           :location "right"}]
        (when (valid-date? (get @vr @highlighted))
          [current-year (get @vr @highlighted)])]
       [pres-description-s
        [gc/text {:color "white"
                  :width "495px"} "We realize that looking at your entire life; from accomplishments to goals and setbacks, helps us to define a relationship that takes all parts of your life into account.  We believe this benefits you holistically."]]])))
